import { render, staticRenderFns } from "./apexChartRatioTitulo.vue?vue&type=template&id=27097190&"
import script from "./apexChartRatioTitulo.vue?vue&type=script&lang=js&"
export * from "./apexChartRatioTitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports